__turbopack_context__.v({
  "avatar": "avatar-module__O9rrzW__avatar",
});
